import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import {
  Button,
  DialogActions,
  DialogContent,
  Grid,
  Radio,
  TextField,
} from "@mui/material";
import PlusIcon from "./../../Assests/plus-icon.svg";
import SelectDataUpload from "./SelectDataUpload";
import {
  createFolder,
  inputFolderValue,
  inputUploadFolderId,
  displayFolderList,
  displayFolderListSuccess,
  displayFolderListError,
  openErrorDialog,
  scenarioaBack,
} from "./../../Redux/Actions/InputData";
import * as actions from "./../../Redux/Actions/InputData";
import CreateFolder from "./CreateFolder";
import { getRequest, postRequest } from "../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  CGO_FLOW_ADD_API,
  CGO_FLOW_ADD_SCENARIO_API,
  // DISPLAY_FOLDER_LIST_BY_USECASE_API,
  DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API,
} from "../../Utils/Config";
import CGOUploadMasterData from "./CGOUploadMasterData";
import "./style.css";
// eslint-disable-next-line react-hooks/rules-of-hooks

function CGOInputForm(props: any) {
  console.log(props, "propssss");
  const [showComponent, setShowComponent] = useState(false);
  const folderData = props.folderData;
  const dispatch: any = useDispatch();
  const [selectFolder, setSelectFolder] = useState();
  const filteredFoldersList = useSelector(
    (state: any) => state.InputDataReducers.filteredFoldersList,
  );
  const [folderOptions, setFolderOptions] = useState([]);
  const [inputFolderName, setInputFolderName] = useState("");
  const [selectFolderTimePeriod, setSelectFolderTimePeriod] = useState("");
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const isCreateFolder = useSelector(
    (state: any) => state.InputDataReducers.isCreateFolder,
  );

  const { isFolderCreated, folderCreationMessage } = useSelector(
    (state: any) => state.InputDataReducers,
  );
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );

  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );
  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData,
  );
  console.log(userData, "userData");
  const [potentionalValue, setPotentialValue] = useState("");
  const [isAnalysis, setIsAnalysis] = useState("");
  const [newScenarioId, setNewScenarioId] = useState(0);

  console.log(folderData, props.selectedFolder, "folderDatafolderData");
  useEffect(() => {
    props.setModalTitleText("COG Opening form");
    return () => {
      props.setModalTitleText("Select/Create Folder & Add Scenario");
    };
  }, []);

  const handleProceedExisting = () => {
    // Try common prop locations for folder/scenario ids (adjust to your actual props)
    const folderId =
      props?.selectedFolderId ||
      props?.folderData?.id ||
      props?.folderData?.folderId;
    const scenarioId =
      props?.selectedScenarioId ||
      props?.selectedFolder?.scenarioId ||
      props?.folderData?.scenarioValue;

    if (folderId && scenarioId) {
      setNewFolderId(folderId);
      setNewScenarioId(Number(scenarioId));
      // open upload component directly
      setShowComponent(true);
    } else {
      // show error if ids are missing
      dispatch(
        openErrorDialog({ message: "Please select a folder and scenario." }),
      );
    }
  };
  // When clicked from the create scenario COG
  const handleClick = () => {
    const urls = API_BASE_URL + CGO_FLOW_ADD_API;
    const params = {
      scenario_id: 0,
      folder_id: 0,
      scenario: folderData.scenarioValue,
      folder: folderData.folderValue,
      potentialLocations: potentionalValue,
      isAnalysis: isAnalysis === "true" ? true : false,
      isUpload: true,
      createdBy: userData.userId,
    };
    postRequest(urls, params, {})
      .then((response) => {
        if (response.status === 200 && response) {
          localStorage.setItem(
            "newCGOScenarioId",
            response.data?.data?.split(",")[1],
          );
          setNewScenarioId(response.data?.data?.split(",")[1]);
          setNewFolderId(response.data?.data?.split(",")[0]);
          if (response.data.message === "Ok") {
            setShowComponent(true);
          }
          setSuccessMessage(response.data.message);
        }
      })
      .catch((error) => {});
  };

  const [successMessage, setSuccessMessage] = useState<any>("");
  const [newFolderId, setNewFolderId] = useState<any>("");

  // Validating scenario when the user selects create scenario cog
  const scenarioHandleClick = () => {
    const urls = API_BASE_URL + CGO_FLOW_ADD_SCENARIO_API;
    const params = {
      scenario_id: 0,
      folder_id: props?.selectedFolder?.id,
      scenario: props?.scenarioValue,
      potentialLocations: potentionalValue,
      isAnalysis: isAnalysis === "true" ? true : false,
      isUpload: true,
      createdBy: userData.userId,
    };
    postRequest(urls, params, {})
      .then((response) => {
        if (response.status === 200 && response?.data?.success === true) {
          if (response.data.message === "Ok") {
            setShowComponent(true);
          }
          setSuccessMessage(response.data.message);
          setNewScenarioId(response.data?.data?.split(",")[1]);
          setNewFolderId(response.data?.data?.split(",")[0]);
          localStorage.setItem(
            "newCGOScenarioId",
            response.data?.data?.split(",")[1],
          );
        } else if (
          response.status === 200 &&
          response?.data?.success === false
        ) {
          setSuccessMessage(response.data.message);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    callFolderFilterApi();
  }, [selectedUsecaseId, selectedCategoryId]);

  const callFolderFilterApi = () => {
    dispatch(displayFolderList());
    const urls = API_BASE_URL + DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    if (selectedUsecaseId && selectedCategoryId) {
      getRequest(
        urls,
        {
          useCase: selectedUsecaseId,
          category: selectedCategoryId,
          createdBy: userData.userId,
        },
        header,
      )
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            console.log(response.data.data, " newwwwwww");
            setFolderOptions(response.data.data);
            dispatch(displayFolderListSuccess(response.data.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayFolderListError(error.message));
        });
    }
  };

  const handleOpenCreateFolder = () => {
    dispatch(createFolder());
  };

  const handleChangeSelectFolder = (e: any) => {
    setSelectFolder(e.target.value);
    if (e.target.value.id !== undefined) {
      console.log(e.target.value.id, "folderIDDDDD");
      dispatch(inputUploadFolderId(e.target.value.id));
    }
  };

  const handleInputFolderName = (e: any) => {
    setInputFolderName(e.target.value);
    dispatch(inputFolderValue(e.target.value));
    //dispatch(inputUploadFolderId(e.target.value.id));
  };

  const handleSelectTimePeriod = (e: any) => {
    setSelectFolderTimePeriod(e.target.value);
  };

  const handleCreateNewFolderold = () => {
    const request = {
      containerName: "container1001",
      directoryName: inputFolderName,
      createdBy: userData.userId,
    };
    dispatch(actions.onInitCreateNewFolder(request));
    // dispatch(createdFolder());
  };

  const handleCreateNewFolder = () => {
    //  console.log('handleCreateNewFolder selectedCategoryId: ', selectedCategoryId);
    const request = {
      id: 0,
      usecase: selectedUsecaseId,
      category: selectedCategoryId,
      folder: inputFolderName,
      folder_time: 1,
      createdBy: userData.userId,
    };
    console.log(selectedUsecaseId, selectedCategoryId, "ids");
    if (selectedUsecaseId > 0 && selectedCategoryId > 0) {
      dispatch(actions.onInitCreateNewFolder(request));
    }
    // dispatch(createdFolder());
  };

  useEffect(() => {
    setFolderOptions(
      props?.folderList || [
        { id: "0", folder: "Select", folder_time: "Select" },
      ],
    );
  }, [props]);

  const handleChangeSelectLine = (e: any) => {
    e.preventDefault();
    const value = e.target.value;
    setIsAnalysis(value);
  };

  const handleGoBack = () => {
    setShowComponent(false);
  };

  return (
    <>
      <>
        {!showComponent && (
          <DialogContent>
            <div className="input-form-upload-page">
              <div
                className="create-new-folder2"
                onClick={handleOpenCreateFolder}
              >
                <div className="potential_container">
                  <div>Number of potential plant locations</div>
                  <TextField
                    onChange={(e) => setPotentialValue(e.target.value)}
                  />
                </div>
                <div className="potential_container2">
                  <div className="container_heading">
                    Do you want to consider existing plants in the analysis?
                  </div>
                  <div>
                    <span>
                      <Radio
                        checked={isAnalysis === "true"}
                        onChange={handleChangeSelectLine}
                        value={true}
                        name="radio-buttons"
                        inputProps={{ "aria-label": "yes" }}
                      />
                    </span>
                    <label>Yes</label>
                    <span>
                      <Radio
                        checked={isAnalysis === "false"}
                        onChange={handleChangeSelectLine}
                        value={false}
                        name="radio-buttons"
                        inputProps={{ "aria-label": "no" }}
                      />
                    </span>
                    <label>No</label>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        )}
        {successMessage !== "Ok" && (
          <h2 style={{ color: "red", paddingLeft: "20px" }}>
            {successMessage}
          </h2>
        )}
        <DialogActions>
          <div
            className={`modal-action ${showComponent ? "modal-action-fullwidth" : ""}`}
          >
            {!showComponent && (
              <>
                <Button
                  variant="outlined"
                  className="cancel"
                  onClick={props.handleGoBack}
                >
                  Go Back
                </Button>
                <Button
                  variant="contained"
                  className="Next"
                  onClick={
                    // if coming from "view existing scenario" (adjust prop name if different)
                    props?.isSelectedScenarios
                      ? handleProceedExisting
                      : props?.selectedFolder &&
                          props.selectRadio === "masterData"
                        ? scenarioHandleClick
                        : handleClick
                  }
                  disabled={isAnalysis === "" || potentionalValue === ""}
                >
                  {/* onClick={props.handleNext}> */}
                  Confirm and proceed to app
                </Button>
              </>
            )}
            {showComponent && (
              <CGOUploadMasterData
                selectLine={isAnalysis}
                handleUploadNow={props.handleUploadNow}
                selectedFolderId={
                  props?.selectedFolder.id || props.selectedFolderId
                }
                selectedScenarioId={props?.selectedScenarioId}
                newScenarioId={newScenarioId}
                newFolderId={newFolderId}
                handleGoBack={handleGoBack}
                handleClose={props.handleClose}
                setModalTitleText={props.setModalTitleText}
                selectRadio={props.selectRadio}
              />
            )}
          </div>
        </DialogActions>
      </>
    </>
  );
}

export default CGOInputForm;
